//import React from "react";
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  FaClipboardList,
  FaChartBar,
  FaUserPlus,
  FaSignOutAlt,
  FaClipboardCheck,
  FaAddressBook,
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";

const NavBarAdmin = () => {
  const [mostrarSubMenu, setMostrarSubMenu] = useState(false);

  const { user, logout } = useAuth();
  const subMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (subMenuRef.current && !subMenuRef.current.contains(event.target)) {
        setMostrarSubMenu(false);
      }
    };

    // 👇 Siempre lo agregamos, pero solo ejecuta si el submenú está abierto
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mostrarSubMenu]);

  if (!user) {
    return null;
  }

  const submenuItemStyle = {
    display: "block",
    color: "white",
    textDecoration: "none",
    padding: "8px 12px",
    borderRadius: "5px",
    marginBottom: "5px",
    fontSize: "14px",
    backgroundColor: "#555",
    transition: "background 0.2s ease",
  };
  const handleLinkClick = () => {
    setMostrarSubMenu(false);
  };

  return (
    <nav
      style={{
        backgroundColor: "#333",
        height: "100%",
        width: "65px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px 0",
        boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
        gap: "30px", // Espaciado entre los íconos aumentado
      }}
    >
      <ul style={{ listStyle: "none", padding: 0, margin: 0, width: "100%" }}>
        {user.tipoRol === "administrador" && (
          <>
            <li style={{ marginBottom: "30px", textAlign: "center" }}>
              {" "}
              {/* Espaciado adicional */}
              <Link
                to="/dashboard"
                style={{ color: "white", textDecoration: "none" }}
              >
                <MdDashboard title="Dashboard" style={{ fontSize: "30px" }} />
              </Link>
            </li>
            <li style={{ marginBottom: "30px", textAlign: "center" }}>
              {" "}
              {/* Espaciado adicional */}
              <Link
                to="/reservas"
                style={{ color: "white", textDecoration: "none" }}
              >
                <FaClipboardList
                  title="Reservas"
                  style={{ fontSize: "30px" }}
                />
              </Link>
            </li>
            <li style={{ marginBottom: "30px", textAlign: "center" }}>
              <Link
                to="/reservasvisualizador"
                style={{ color: "white", textDecoration: "none" }}
              >
                <FaClipboardCheck
                  title="Visualizador de reservas"
                  style={{ fontSize: "30px" }}
                />
              </Link>
            </li>
            <li style={{ marginBottom: "30px", textAlign: "center" }}>
              {" "}
              {/* Espaciado adicional */}
              <Link
                to="/reservas_usuario"
                style={{ color: "white", textDecoration: "none" }}
              >
                <FaAddressBook
                  title="Mis Reservas"
                  style={{ fontSize: "30px" }}
                />
              </Link>
            </li>
            <li
              ref={subMenuRef} // 👈 ahora el ref va en el <li> entero
              style={{
                marginBottom: "30px",
                textAlign: "center",
                position: "relative",
              }}
            >
              <div
                onClick={() => setMostrarSubMenu(!mostrarSubMenu)}
                title="Informes y buscadores"
                style={{ color: "white", cursor: "pointer" }}
              >
                <FaChartBar style={{ fontSize: "30px" }} />
              </div>

              {mostrarSubMenu && (
                <ul
                  style={{
                    position: "absolute",
                    top: "40px",
                    left: "60px",
                    backgroundColor: "#444",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 5px rgba(0,0,0,0.4)",
                    zIndex: 10,
                    listStyle: "none",
                    minWidth: "220px",
                  }}
                >
                  <li>
                    <Link
                      onClick={handleLinkClick}
                      to="/informes"
                      style={submenuItemStyle}
                    >
                      🧾 Reservas por DNI
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={handleLinkClick}
                      to="/informes_federaciones"
                      style={submenuItemStyle}
                    >
                      🏅 Por federación
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={handleLinkClick}
                      to="/miembros_por_habitacion"
                      style={submenuItemStyle}
                    >
                      🛏️ Miembros por habitación
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={handleLinkClick}
                      to="/informes_por_tipo_miembro"
                      style={submenuItemStyle}
                    >
                      🧍 Por tipo de miembro
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li style={{ marginBottom: "30px", textAlign: "center" }}>
              <Link
                to="/crear_usuarios"
                style={{ color: "white", textDecoration: "none" }}
              >
                <FaUserPlus
                  title="Crear usuario"
                  style={{ fontSize: "30px" }}
                />
              </Link>
            </li>
          </>
        )}
        <li style={{ marginTop: "auto", textAlign: "center" }}>
          <button
            onClick={logout}
            style={{
              background: "transparent",
              color: "white",
              border: "none",
            }}
            title="Logout"
          >
            <FaSignOutAlt style={{ fontSize: "30px" }} />
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default NavBarAdmin;
